module.exports = __webpack_public_path__ + "webpc/img/icon_gz_2.91f46024.png";